import { useAuth } from '../contexts/AuthContext'
import { ShieldOff } from 'lucide-react'
import { hasAdminRights } from '../lib/roles'

interface AdminRouteProps {
  children: React.ReactNode
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { profile, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-600"></div>
      </div>
    )
  }

  if (!profile || !hasAdminRights(profile.role)) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <ShieldOff className="h-16 w-16 text-gray-400 mx-auto mb-4" />
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">Admin Access Required</h2>
          <p className="text-gray-500 dark:text-gray-400 mb-4">This page is restricted to administrators only.</p>
          <a
            href="/dashboard/students"
            className="inline-block px-4 py-2 bg-brand-600 text-white rounded-lg hover:bg-brand-700"
          >
            Go to Students
          </a>
        </div>
      </div>
    )
  }

  return <>{children}</>
}